export {
  defaultBackgroundVideoJsOptions,
  defaultVideoJsOptions
} from './defaultVideoJsOptions'
